<template>
  <div :class="['contractPage', {'full-screen': fullScreen}]">
    <header v-if="showPageTitle" class="pageTitle">
        <h2>{{pageTitle}}</h2>
    </header>
    <div class="content-page" v-html="pageData">

    </div>
  </div>
</template>

<script>
  import api from "@/api";

  export default {
    name: "UserAgreement",
    props: {
      userAgreementType : {
        type: Number,
        default: -1
      },
      showPageTitle: {
        type: Boolean,
        default: false
      },
      fullScreen: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        pageData: '',
        pageTitle: ''
      }
    },
    watch: {
      userAgreementType: {
        async handler (val) {
            console.log(val)
            if(val) await this.initPage(val)
        },
        immediate: true
      }
    },
    methods: {
      async initPage (type) {
        const { success, data } = await api.user.getAgreementByType({
          userAgreementType: type
        })
        if (success && data) {
          this.pageData = data.content;
          this.pageTitle = data.title;
          document.title = `${this.pageTitle}|${document.title}`;
          this.$emit('page-load', data)
        }
      }
    }
  }
</script>

<style lang="less">
.contractPage {
  width: 90%;
  margin: 0 auto;
  &.full-screen {
    width: 100%;
  }

  .pageTitle {
    text-align: center;
    & h2 {
      margin-top: 25px;
      margin-bottom: 15px;
      font-size: 32px;
      font-weight: normal;
      color: #478cc7;
    }
  }

  .content-page {
    font-size: 14px;
    line-height: 1.4;
    .bar {
      display: none;
    }

    .content-title {
      height: 40px;
      line-height: 40px;
      font-size: 24px;
      color: #fff;
    }

    .page {
      position: relative;
      background-color: transparent !important;
      //padding-bottom: 88px;
    }

    .content {
      position: relative;
      top: 0;
      .content-block {
        margin: 0;
        background: none;
      }
    }

    p {
      margin: 10px 0;
    }
    .table {
      width: 100%;
      overflow-x: auto;
      border-collapse: collapse;
      border: 2px solid #808080;
    }
    .table .th {
      padding: 8px;
      border: 2px solid #808080;
    }
    .table .td {
      vertical-align: top;
      padding: 8px;
      border: 2px solid #808080;
    }
    .table .th p,
    .table .td p {
      margin: 0;
    }
    .tableBox .table {
      border-collapse: collapse;
    }
    a {
      cursor: pointer;
    }
  }
}
.pageFooter {
  height: 45px;
}
</style>